export const tableOption = {
  dialogClickModal: false,
  refreshBtn: false,
  searchBtn: false,
  addBtn: false,
  border: true,
  stripe: true,
  page: true,
  align: 'center',
  menuAlign: 'center',
  column: [
    {
      label: '敏感词',
      prop: 'word',
      clearable: false,
      search: false,
      maxlength: 45,
      rules: [{
        required: true,
        message: "请输入敏感词",
        trigger: "blur",
      },
      {
        max: 45,
        message: '敏感词不能超过45个字符',
        trigger: 'blur'
      }]
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
      editDisabled: true,
    },
    // {
    //   label: '创建者',
    //   prop: 'creator',
    //   editDisabled: true,
    // },
  ]
}